var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinkOrangeMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1283 381",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6599_74517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153 -28.5L2161 -22L2171 633L48.5 637.5L153 -28.5Z",
    fill: "url(#paint0_linear_6599_74517)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.955 -639H342.948C346.735 -639.006 350.476 -638.126 353.897 -636.424C357.317 -634.722 360.331 -632.241 362.716 -629.163C365.102 -626.086 366.799 -622.489 367.684 -618.636C368.569 -614.784 368.619 -610.773 367.831 -606.897L180.069 317.593L599.444 -178.784C601.827 -181.602 604.756 -183.857 608.036 -185.4C611.317 -186.942 614.873 -187.737 618.47 -187.732H928.888C933.273 -187.724 937.581 -186.532 941.396 -184.271C945.21 -182.01 948.402 -178.756 950.661 -174.825L1192.03 246.738L1551.7 -178.784C1554.08 -181.596 1557.01 -183.848 1560.29 -185.39C1563.57 -186.932 1567.12 -187.73 1570.72 -187.732H1793.63C1798.52 -187.725 1803.3 -186.246 1807.4 -183.47C1811.5 -180.694 1814.75 -176.74 1816.76 -172.081C1818.77 -167.423 1819.45 -162.257 1818.72 -157.204C1817.99 -152.151 1815.89 -147.424 1812.66 -143.59L1287.78 477.422L1150.76 1151.58C1149.56 1157.55 1146.43 1162.9 1141.9 1166.74C1137.37 1170.58 1131.71 1172.68 1125.88 1172.67H936.457C932.671 1172.66 928.935 1171.77 925.521 1170.06C922.108 1168.34 919.102 1165.86 916.723 1162.78C914.344 1159.7 912.652 1156.1 911.77 1152.25C910.888 1148.4 910.839 1144.39 911.625 1140.51L1046.41 477.91L759.63 -23.9648L470.725 317.668L746.048 798.665C748.346 802.695 749.583 807.29 749.632 811.982C749.682 816.674 748.543 821.296 746.331 825.378C744.119 829.461 740.913 832.858 737.039 835.223C733.165 837.589 728.761 838.839 724.275 838.847H492.758C488.372 838.845 484.062 837.656 480.246 835.394C476.431 833.132 473.24 829.876 470.985 825.941L180.042 317.73L78.563 817.385C77.3607 823.355 74.2313 828.711 69.7001 832.552C65.169 836.393 59.5121 838.486 53.6797 838.48H-143.312C-147.103 838.478 -150.844 837.59 -154.265 835.881C-157.685 834.173 -160.697 831.688 -163.082 828.606C-165.466 825.524 -167.163 821.925 -168.048 818.069C-168.932 814.214 -168.983 810.201 -168.196 806.323L121.124 -617.96C122.334 -623.911 125.461 -629.247 129.98 -633.076C134.5 -636.906 140.139 -638.997 145.955 -639ZM-404.888 265.834L-634.28 165.839C-701.206 135.472 -726.815 115.407 -722.875 90.8424C-719.142 68.0127 -702.139 46.9183 -638.375 46.9183H-166.112C-160.322 46.898 -154.711 44.8131 -150.206 41.0076C-145.701 37.2021 -142.571 31.9036 -141.333 25.9865L-104.63 -155.404C-103.825 -159.283 -103.86 -163.301 -104.734 -167.163C-105.608 -171.025 -107.298 -174.634 -109.679 -177.723C-112.061 -180.813 -115.074 -183.305 -118.497 -185.017C-121.921 -186.729 -125.667 -187.617 -129.461 -187.615H-617.121C-848.794 -186.151 -942.106 -56.8729 -970.774 79.4547C-1007.06 251.952 -875.336 331.775 -781.091 372.933L-529.408 479.761C-467.873 505.682 -458.127 529.434 -464.711 556.005C-471.865 584.8 -493.845 603.942 -572.124 603.942H-1056.83C-1062.63 603.94 -1068.26 606.016 -1072.78 609.824C-1077.29 613.632 -1080.43 618.943 -1081.66 624.874L-1118.47 806.21C-1119.24 810.076 -1119.17 814.073 -1118.28 817.91C-1117.39 821.748 -1115.7 825.33 -1113.32 828.398C-1110.94 831.466 -1107.94 833.942 -1104.54 835.648C-1101.13 837.353 -1097.41 838.245 -1093.64 838.259H-572.072C-332.674 836.035 -249.419 706.215 -219.559 564.844C-181.82 385.677 -288.04 317.676 -404.888 265.834Z",
    fill: "url(#paint1_linear_6599_74517)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6599_74517",
    x1: 1086.83,
    y1: 1266.78,
    x2: 1086.83,
    y2: 6.20244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9100D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F94CB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FC6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6599_74517",
    x1: -1987.76,
    y1: -639,
    x2: 1399.8,
    y2: 1793.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9100D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F94CB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FC6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E1C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6599_74517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1283,
    height: 381,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkOrangeMobile);
export default __webpack_public_path__ + "static/media/pink-orange-mobile.6fd8572b1f29cdc650fda6bcbe70ef6c.svg";
export { ForwardRef as ReactComponent };